import type { ReactNode } from "react";
import { PMDialog } from "@/ds/vendor";

// Every modal in the app goes through here: PMDialog with a named size from the
// foundation scale (sm 440 · md 560 · lg 760 · xl 980), so dialogs stay uniform.
const W = { sm: 440, md: 560, lg: 760, xl: 980 } as const;

export function Modal({ open, onClose, title, subtitle, size = "md", footer, children }: { open: boolean; onClose: () => void; title: string; subtitle?: string; size?: keyof typeof W; footer?: ReactNode; children: ReactNode }) {
  return <PMDialog open={open} onClose={onClose} title={title} subtitle={subtitle} maxWidth={W[size]} footer={footer}>{children}</PMDialog>;
}
